const ReactRailsUJS = require("react_ujs");

// eslint-disable-next-line import/prefer-default-export
export const setSlimRequireContext = componentRequireContext => {
  ReactRailsUJS.useContext(componentRequireContext);
  ReactRailsUJS.mountComponents();
};
